import {
  addDaysToYmd,
  studioTodayYmd,
} from "@/lib/utils/date/studio-clock";

/** 7-day upcoming window for teacher dashboard private-lesson signals. */
export function getTeacherUpcomingPrivateLessonsRange(
  now: Date = new Date(),
): {
  start: string;
  end: string;
} {
  const start = studioTodayYmd(now);
  return {
    start,
    end: addDaysToYmd(start, 7),
  };
}
